
const PAGE_TRANSITION_DURATION = 0.3;
const PAGE_TRANSITION_DISTANCE = 30;

export {PAGE_TRANSITION_DURATION, PAGE_TRANSITION_DISTANCE}